// Match calculate_course_progress: select the delivery mode before applying
// publication and self-paced accreditation rules.
export const getCountableEnrollmentLessons = (lessons, enrollment) => {
  const deliveryMode = enrollment.delivery_mode || "self_paced";
  const modeLessons = lessons.filter(
    (lesson) => (lesson.delivery_mode || "self_paced") === deliveryMode,
  );
  const publishedLessons = modeLessons.filter(
    (lesson) => lesson.is_published === true,
  );
  const visibleLessons =
    publishedLessons.length > 0 ? publishedLessons : modeLessons;

  if (
    deliveryMode === "self_paced" &&
    enrollment.accreditation_type === "non_accredited"
  ) {
    const nonAssessmentLessons = visibleLessons.filter(
      (lesson) => !["quiz", "assignment"].includes(lesson.type),
    );
    if (nonAssessmentLessons.length > 0) return nonAssessmentLessons;
  }

  return visibleLessons;
};
